module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"平均滞在時間"}}')
  delete Component.options._Ctor
}
